var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "composer-menu" }, [
    _c(
      "div",
      { staticClass: "row" },
      _vm._l(_vm.brickDefinitions, function(ref) {
        var component = ref.component
        var definition = ref.definition
        return _c(
          "div",
          { key: definition.type, staticClass: "col-6" },
          [
            _c(component, {
              tag: "component",
              staticClass: "composable",
              class: [definition.name, _vm.canWrite ? "addable" : ""],
              attrs: {
                displayName: definition.displayName,
                icon: definition.icon
              },
              nativeOn: {
                click: function($event) {
                  return _vm.addBrick(definition)
                }
              }
            })
          ],
          1
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }